import { Alert } from "@/components/ui/Alert";

export function StammdatenWriteHint() {
  return (
    <Alert variant="info" title="Nur Ansicht">
      Sie können diesen Bereich ansehen, aber nicht ändern. Zum Bearbeiten ist die Rolle{" "}
      <strong className="font-medium text-label">Camping-Admin</strong> erforderlich – wenden Sie
      sich bei Bedarf an Ihre Platzleitung.
    </Alert>
  );
}
